export default {"src":"/_next/static/media/comment_icon.a6b6528c.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};